import React, { FC } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { AccountGroup as AccountGroupIcon } from "mdi-material-ui";
import { LoadingButton } from "@mui/lab";

export const AnaliseTurma: FC<{
  titulo: string;
  texto: string;
  loading: boolean;
  saving: boolean;
  onChange: (texto: string) => void;
  onSave: () => void;
}> = ({ titulo, texto, loading, saving, onChange, onSave }) => {
  return (
    <Box sx={{ pb: 6 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" color="primary">
          Análise da Turma, Aspectos Coletivos
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {titulo}
        </Typography>
      </Box>

      <Card variant="outlined" sx={{ borderRadius: 0, boxShadow: "none" }}>
        <CardContent>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ display: "flex", alignItems: "center", mb: 1 }}
          >
            <AccountGroupIcon sx={{ mr: 1, color: "primary.main" }} />
            Primeiro Momento: Aspectos Coletivos
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Neste espaço, não insira nomes de alunos. Foque na análise coletiva,
            ritmo de aprendizagem e dinâmica da turma como um todo.
          </Typography>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TextField
              fullWidth
              multiline
              rows={6}
              variant="outlined"
              placeholder="Insira o parecer geral da turma aqui..."
              value={texto}
              onChange={(event) => onChange(event.target.value)}
              sx={{ mt: 2, bgcolor: "#fafafa" }}
            />
          )}
        </CardContent>
      </Card>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={onSave}
          loading={saving}
        >
          Salvar
        </LoadingButton>
      </Box>
    </Box>
  );
};
